import {
  CalendarMonth,
  DesignServices,
  DocumentScanner,
  Explore,
  ListAlt,
  Report,
  RequestPage,
} from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import * as React from "react";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import DrawerMenu from "./DrawerMenu";

export default function AppBarMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);

  // navigate
  const navigate = useNavigateToTop();

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePlanningClicked = () => {
    navigate("/planner");
  };
  const handleLastVisitClicked = () => {
    navigate("/planner/lastVisit");
  };

  const HnaldeResourceListsClicked = () => {
    navigate("/resourceLists");
  };
  const handleReportingClicked = () => {
    navigate("/reporting");
  };
  const handleExplorerClicked = () => {
    navigate("/explorer");
  };

  return (
    <React.Fragment>
      {/* <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Menu">
          <IconButton
            onClick={handleClick}
            size="small"
            // sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <MenuIcon color="secondary" />
          </IconButton>
        </Tooltip>
      </Box> */}
      <DrawerMenu />
    </React.Fragment>
  );
}
